import mqtt from 'mqtt/dist/mqtt';
import { createContext } from 'react';

export const MqttContext = createContext<mqtt.MqttClient | null>(null as any);
MqttContext.displayName = 'MqttContext';
